import { render, staticRenderFns } from "./CompraDetalhesLog.vue?vue&type=template&id=3843a670"
import script from "./CompraDetalhesLog.vue?vue&type=script&lang=js"
export * from "./CompraDetalhesLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports